import { Table } from "antd";
import React, { useEffect, useState } from "react";
import { useCentralStore } from "../../store/appContext";
import "./tableStyle.css";
import Selector from "../../components/common/selector/selector";
import ActionTypes from "../../store/actionTypes";
import API from "../../api";
import resources from "../../components/common/resources.json";

const SlaReport = () => {
  const [{ slaReportCountSuccess, carrierThemeData, selectedAccountingMonth, userDetails, userData, reportFilterDuration }, dispatch] = useCentralStore();
  const [deviceRepairPlan, setDeviceRepairPlan] = useState();
  const [rebateData, setRebateData] = useState([]);
  const [rebateMsg, setRebateMsg] = useState();

  const { theme } = carrierThemeData;

  let CustomerServiceSLA = slaReportCountSuccess?.GetSLADetailsResponse?.CustomerServiceSLA;

  let deviceRepairCategory = CustomerServiceSLA?.filter(
    (node) => node.Category === "Device Repair"
  );
  let TechnicalSLA = slaReportCountSuccess?.GetSLADetailsResponse?.TechnicalSLA;

  // useEffect(() => {
  //   // setDeviceRepairPlan(deviceRepairPlanSLAData);
  // }, [TechnicalSLA, deviceRepairCategory]);

  let technicalSLAData =
    Array.isArray(TechnicalSLA) &&
    TechnicalSLA?.map((item) => {
      const {
        "ExpectedSLA%": expectedSlaPercentage,
        "ActualSLA%": actualSlaPercentage,
        ...rest
      } = item;
      return {
        ...rest,
        category: item?.Category,
        month: reportFilterDuration?.duration,
        expectedSla: expectedSlaPercentage,
        actualSla: actualSlaPercentage,
        deviation:
          actualSlaPercentage > 0 && actualSlaPercentage < expectedSlaPercentage
            ?  Math.ceil(
              ((expectedSlaPercentage - actualSlaPercentage)/100) * 0.65 * 4140
             )
            : 0,
      };
    });

  // let deviceRepairPlanSLAData = CustomerServiceSLA?.filter(
  //   (node) => node.Category !== "Delivery" &&
  //    node.Category !== "Acceptance/ Rejection of Service Requests with communication to Subscriber" &&
  //    node.Category !== "Customer complaints management" &&
  //    node.Category !== "Rejection rate" 
  // )?.map((item) => {
  //   const {
  //     "ExpectedSLA%": expectedSlaPercentage,
  //     "ActualSLA%": actualSlaPercentage,
  //     ...rest
  //   } = item;
  //   return {
  //     ...rest,
  //     category: item?.Category,
  //     expectedSla: expectedSlaPercentage,
  //     actualSla: actualSlaPercentage,
  //     deviation:
  //       actualSlaPercentage > 0 && actualSlaPercentage < expectedSlaPercentage
  //         ?  Math.ceil(
  //           ((expectedSlaPercentage - actualSlaPercentage)/100) * 0.65 * 4140
  //          )
  //         : 0,
  //   };
  // });

  const customerSla = CustomerServiceSLA?.filter(
    (node) => node.Category !== "Device Repair"
  )?.map((item) => {
    const {
      "ExpectedSLA%": expectedSlaPercentage,
      "ActualSLA%": actualSlaPercentage,
      ...rest
    } = item;
    return {
      ...rest,
      category: item?.Category,
      month: reportFilterDuration?.duration,
      expectedSla: expectedSlaPercentage,
      actualSla: actualSlaPercentage,
      deviation:
        actualSlaPercentage > 0 && actualSlaPercentage < expectedSlaPercentage
          ? Math.ceil(
             ((expectedSlaPercentage - actualSlaPercentage)/100) * 0.65 * 4140
            )
          : 0,
    };
  });


  let tableColumns = [
    {
      title: "CATEGORY",
      dataIndex: "category",
      key: "category",
      align: "center",
      width: 300,
    },
    {
      title: "MONTH",
      dataIndex: "month",
      key: "month",
      align: "center",
      width: 150,
    },
    {
      title: "EXPECTED SLA %",
      dataIndex: "expectedSla",
      key: "expectedSla",
      align: "center",
      width: 150,
    },
    {
      title: "ACTUAL SLA %",
      dataIndex: "actualSla",
      key: "actualSla",
      align: "center",
      width: 150,
    },
    {
      title: "DEVIATION %",
      dataIndex: "deviation",
      key: "deviation",
      align: "center",
      width: 150,
    },
  ];

  const rowClassName = (record, index) => {
    if (record.rebate > 0) {
      return "amber-row";
    }
    return "";
  };

  const dynamicStyle = {
    '--th-header': theme?.colors?.textWhiteColor,
  }

  // const [months, setMonths] = useState([]);
  // let monthNames = [
  //   "Jan",
  //   "Feb",
  //   "Mar",
  //   "Apr",
  //   "May",
  //   "Jun",
  //   "Jul",
  //   "Aug",
  //   "Sep",
  //   "Oct",
  //   "Nov",
  //   "Dec",
  // ];

  // useEffect(() => {
  //   const today = new Date();
  //   let d;
  //   let month = [];
  //   for (let i = 2; i >= 0; i -= 1) {
  //     d = new Date(today.getFullYear(), today.getMonth() - i, 1);
  //     console.log("d", d);
  //     month.unshift({
  //       name: `${monthNames[d.getMonth()]}-${d
  //         .getFullYear()
  //         .toString()
  //         .substr(-2)}`,
  //       value: `${monthNames[d.getMonth()]}-${d.getFullYear().toString()}`,
  //     });
  //     dispatch({
  //       type: ActionTypes.SELECTED_ACCOUNTING_MONTH,
  //       payload: selectedAccountingMonth
  //         ? selectedAccountingMonth
  //         : month[0]?.value,
  //     });
  //     setMonths(month);
  //   }
  // }, []);

  // const handleChange = (name, value) => {
  //   dispatch({
  //     type: ActionTypes.SELECTED_ACCOUNTING_MONTH,
  //     payload: value,
  //   });
  // };
  const setLoading = (action) => {
    dispatch({ type: ActionTypes.SET_LOADING, payload: action });
  };

  const handleSubmit = () => {
    setLoading(true)
    let payload = {
      "RebateValue": rebateData,
      "RebateRange": reportFilterDuration?.duration
    }
    API[ActionTypes.ADD_REBATE](payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0])
      .then(({ data }) => {
          setLoading(false);
          setRebateMsg(data?.AddRebateResponse?.Message)
          setTimeout(() => {
            setRebateMsg(""); // Clear the message
          }, 2000);
      })
      .catch((err) => {
          setLoading(false);
          dispatch({ type: ActionTypes.SET_API_ERROR, data: true });
          let _payload = {
              level: resources.POST_LOGGER_ERROR,
              category: resources.POST_LOGGER_API,
              ApiName: resources.POST_LOGGER_APINAME,
              message: {
                  error: err,
                  info: {
                      idToken: "",
                  },
              },
          };
          API[ActionTypes.POST_LOGGER](_payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0]);
      });
  };

  useEffect(() =>{    
    setRebateData('');
    getMonthWiseRebate()
  }, [reportFilterDuration?.duration])

  let getMonthWiseRebate = () => {
    setLoading(true)
    let payload = {
      "RebateRange": reportFilterDuration?.duration
    }
    API[ActionTypes.GET_MONTHWISE_REBATE](payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0])
      .then(({ data }) => {
          setLoading(false);
          setRebateData(data?.GetRebateResponse?.[0]?.RebateValue)
      })
      .catch((err) => {
          setLoading(false);
          dispatch({ type: ActionTypes.SET_API_ERROR, data: true });
          let _payload = {
              level: resources.POST_LOGGER_ERROR,
              category: resources.POST_LOGGER_API,
              ApiName: resources.POST_LOGGER_APINAME,
              message: {
                  error: err,
                  info: {
                      idToken: "",
                  },
              },
          };
          API[ActionTypes.POST_LOGGER](_payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0]);
      });
  }
  

  return (
    <div className="py-3 mx-auto">
      {/* <div className="flex items-center justify-end text-black mt-[-40px]">
          <Selector
            key="Channel Dropdown"
            options={months}
            label="Month"
            value={selectedAccountingMonth}
            onSelect={(name, val) => handleChange(name, val)}
            placeholder="Select month"
            isStarhub={true}
            theme={theme}
          />
        </div> */}
      <p className="flex flex-row items-center justify-center mb-4 font-bold text-black">
        Customer SLA
      </p>
      <div className="flex flex-row items-center justify-center mb-3 mx-7">
        <Table
          columns={tableColumns}
          dataSource={customerSla}
          rowKey="data"
          key="data"
          pagination={false}
          className="mb-6 border-current border-white table-css"
          style={dynamicStyle}
          locale={{ emptyText: "No data" }}
          rowClassName={rowClassName}
        />
      </div>
      {/* <p className="flex flex-row items-center justify-center mb-4 font-bold text-black">
        Device Repair SLA
      </p>
      <div className="flex flex-row items-center justify-center mb-3 mx-7">
        <Table
          columns={tableColumns}
          dataSource={deviceRepairPlan}
          rowKey="data"
          key="data"
          pagination={false}
          className="mb-6 border-current border-white table-css"
          style={dynamicStyle}
          locale={{ emptyText: "No data" }}
          rowClassName={rowClassName}
        />
      </div> */}
      <p className="flex flex-row items-center justify-center mb-4 font-bold text-black">
        Technical SLA
      </p>
      <div className="flex flex-row items-center justify-center mb-3 mx-7">
        <Table
          columns={tableColumns}
          dataSource={technicalSLAData}
          rowKey="data"
          key="data"
          pagination={false}
          className="mb-10 border-current border-white table-css"
          style={dynamicStyle}
          locale={{ emptyText: "No data" }}
          rowClassName={rowClassName}
        />
      </div>
      <div className="flex flex-col items-center w-full max-w-md mx-auto p-4">  
        <div className="relative mb-4 flex items-center justify-between w-full"> {/* Adjusted to flex */}
          <input
            type="number"
            id="floating_outlined"
            value={rebateData} // Bind input value to rebateData state
            onChange={(e) => setRebateData(e.target.value)} // Update state on change
            className="block w-2/3 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 bg-transparent rounded-lg border-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-gray-500 focus:outline-none focus:ring-0 focus:border-gray-600 peer"            
          />
          <label
            htmlFor="floating_outlined"
            className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-gray-600 peer-focus:dark:text-gray-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
            style={{ color: 'gray' }}
          >
            Total $ Rebate
          </label>

          {/* Button section now here */}
          <div className="flex w-1/3 justify-between"> {/* Adjusted for buttons */}
            {!rebateData && 
              <button
                onClick={handleSubmit}
                className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded ml-4"
              >
                Submit
              </button>
            }
            
            {rebateData && ( // Show the Update button only if rebateData is not empty
              <button
                onClick={handleSubmit}
                className="bg-yellow-500 hover:bg-yellow-700 text-white font-bold py-2 px-4 rounded ml-4"
              >
                Update
              </button>
            )}
          </div>
        </div>
      </div>
      {rebateMsg && (
        <p class="flex flex-col items-center w-full max-w-md mx-auto p-4 text-green-500">
          {rebateMsg}
        </p>
      )}
    </div>
  );
};

export default SlaReport;
